import React, { useState, useRef, useEffect } from 'react';
import './CategoryFilter.css'; // Import the CSS file
import { IoFilter } from "react-icons/io5";

export function CategoryFilter({ categories, currentCategoryKeys, setCurrentCategoryKeys, size=30 }) {
    const [isOpen, setIsOpen] = useState(false);
    const [stagedCategories, setStagedCategories] = useState(currentCategoryKeys);
    const containerRef = useRef(null);

    useEffect(() => {
        // Sync staged changes with currentCategoryKeys prop
        setStagedCategories(currentCategoryKeys);
    }, [currentCategoryKeys]);

    useEffect(() => {
        if (!isOpen) {
            setStagedCategories(currentCategoryKeys);
        }
    }, [isOpen]);

    const toggleCategory = (categoryKey) => {
        if (stagedCategories.includes(categoryKey)) {
            setStagedCategories(stagedCategories.filter(c => c !== categoryKey));
        } else {
            setStagedCategories([...stagedCategories, categoryKey]);
        }
    };

    const handleOptionClick = (categoryKey) => {
        toggleCategory(categoryKey);
    };

    const applyChanges = () => {
        setCurrentCategoryKeys(stagedCategories);
        setIsOpen(false); // Optionally close the dropdown upon applying changes
    };

    const clearSelections = () => {
        setStagedCategories([]);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="categoryFilterContainer" ref={containerRef}>
            <button className="categoryFilterButton" onClick={() => setIsOpen(!isOpen)}>
                <p className='numSelectedCategoriesText'>{currentCategoryKeys.length}</p>
                <IoFilter color={'#F2EFF4'} size={size} />
            </button>
            {isOpen && (
                <div className="categoryFilterOptionsContainer">
                    <div className="categoryFilterOptions">
                        {categories.map((category) => (
                            <div key={category.key} className={`categoryFilterOption ${stagedCategories.includes(category.key) ? 'selected' : ''}`}>
                                <input type="checkbox"
                                    id={category.key}
                                    name={category.category}
                                    checked={stagedCategories.includes(category.key)}
                                    onChange={() => handleOptionClick(category.key)}
                                />
                                <label htmlFor={category.key}>{category.category}</label>
                            </div>
                        ))}
                    </div>
                    <div className="categoryFilterControls">
                        <button className="categoryFilterControlButton" onClick={applyChanges}>Apply Changes</button>
                        <button className="categoryFilterControlButton" onClick={clearSelections}>Clear</button>
                    </div>
                </div>
            )}
        </div>
    );
}
